import type { ReactNode } from 'react';

export const symbol_water_loss: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M444-330q-52 0-102 14.5T247-275l15 135h436l17-150h-18q-37 0-68-5.5T544-316q-25-7-49.5-10.5T444-330Zm-204-10q47-24 98.96-37 51.97-13 105.04-13 30 0 59.5 4t56.5 12q51.13 14 78.23 19 27.09 5 57.77 5h25l52-470H187l53 480Zm22 260q-23 0-40.34-14.93Q204.31-109.86 202-133l-74-673q-3-30 17.11-52 20.1-22 49.89-22h570q29.79 0 49.89 22Q835-836 832-806l-74 673q-2.31 23.14-19.66 38.07Q721-80 698-80H262Zm182-60h254-436 182Z"
		/>
	</svg>
);
